import { CompositeFilterDescriptor, FilterDescriptor } from "@progress/kendo-data-query";
import { UploadOnStatusChangeEvent } from "@progress/kendo-react-upload";
import { dispatchProblemDetails } from "../services/api";

export const kendoUploadOnStatusChangeEventHandler = (e: UploadOnStatusChangeEvent, onSuccess?: () => void) => {
  if (e.response && e.response.request !== null) {
    if (e.response.request.status === 200 && e.response.request.status < 300) {
      onSuccess && onSuccess();
    } else if (e.response.request.status !== 500 && e.response.response.headers["content-type"].indexOf("application/problem+json") > -1) {
      dispatchProblemDetails(e.response.response.data);
    } else {
      alert("An unexpected error has occurred. Do not try to reupload the file. See support.");
    }
  }
}

// If true, TypeScript will treat `d` as CompositeFilterDescriptor in that branch/function
function isComposite(d: CompositeFilterDescriptor | FilterDescriptor): d is CompositeFilterDescriptor {
  // `.filters` is an array that can contain FilterDescriptor(s) or nested CompositeFilterDescriptor(s)
  return Array.isArray((d as CompositeFilterDescriptor).filters);
}

// Mutates its argument - Clone before usage
// Recursive filter-trimmer
export function trimFilters(d: CompositeFilterDescriptor | FilterDescriptor): void {
  if (isComposite(d)) {
    // CompositeFilterDescriptor - drill down into child filters
    d.filters.forEach(trimFilters);
  } else {
    // single FilterDescriptor - actual field/value pair
    const fd = d as FilterDescriptor;
    const v = fd.value;

    if (typeof v === 'string') {
      // Trim plain string values
      fd.value = v.trim();
    } else if (Array.isArray(v) && v.every(x => typeof x === 'string')) {
      // Trim each string inside string[] (e.g. multi-select filters)
      fd.value = (v as string[]).map(s => s.trim());
    }
    // numbers, booleans, Dates, etc. are left as-is
  }
}